import { render, staticRenderFns } from "./ChallengeTerminal.vue?vue&type=template&id=36650014&scoped=true&"
import script from "./ChallengeTerminal.vue?vue&type=script&lang=ts&"
export * from "./ChallengeTerminal.vue?vue&type=script&lang=ts&"
import style0 from "./ChallengeTerminal.vue?vue&type=style&index=0&id=36650014&prod&lang=scss&scoped=true&"
import style1 from "./ChallengeTerminal.vue?vue&type=style&index=1&id=36650014&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36650014",
  null
  
)

export default component.exports